<template>
  <div id="app">
		<router-view  v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
    provide () {
        return {
            reload:this.reload
          }
    },
data(){
    return{
         isRouterAlive : true
    }
},
methods: {
    reload(){
        this.isRouterAlive =false;
        this.$nextTick(()=>{
            this.isRouterAlive =true;
        });
  },
}
}
</script>

<style>
@font-face{
  font-family: 'SourceHanSansCN-Normal';
  src: url('../static/css/font/SourceHanSansCN-Normal.ttf');
}

html, body {
	-ms-overflow-style:scrollbar;
	font-family: 'SourceHanSansCN-Normal'!important;
  /* overflow: overlay; */
	/* overflow-y:scroll; */
}
.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6{
	font-family: 'SourceHanSansCN-Normal'!important;
}
#app {
  font-size: 14px;
  text-align: center;
}
nav{
	margin-bottom:100px!important;
}
/*foot顶部分割线样式*/
/* .footTopLine{
	height:40px;
	background:#F2F2F3;
}
.footBottomLine{
	height:40px;
	background:#F2F2F3;
} */

/*手机端样式*/
@media (max-width:768px) {
  #app{
    margin-top: 70px;
    overflow: hidden;
  }
	.textStyle{
		font-size:16px!important;
		color:#6c6c6c!important;
		text-align: justify;
		line-height: 1.75;
		padding:0!important;
	}
	.MOpaddingLR{
		padding-left:15px!important;
		padding-right:15px!important;
	}
}
/* 翻页动画 */
 .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    will-change: transform;
    transition: all 500ms;
    position: absolute;
  }
  .slide-right-enter {
    opacity: 1;
    transform: translate3d(-100%, 0, 0);
  }

  .slide-right-leave-active {
    opacity: 1;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-enter {
    opacity: 1;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-leave-active {
    opacity: 1;
    transform: translate3d(-100%, 0, 0);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue